import React from 'react'
import './style.css'
import {Box, Typography, Link, Button} from '@mui/material'

//import containers
import { Span } from '../../containers';

//import assets
import { logoTransparent } from '../../assets';

//import icons
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
// import DiscordIcon from '../../assets/myIcons';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { FlipCard } from '../Animations';

const Footer = () => {
    const footerMenu = [
        {name:'Residential Spaces', path:''},
        {name:'Industrial Facilities', path:''},
        {name:'Institutional Buildings', path:''},
        {name:'Commercial Spaces', path:''},
        {name:'Communal Spaces', path:''},
    ]

    const footerIcons = [
        {name:'linked-in', path:'https://www.linkedin.com/company/pangu-design-build/', icon:<LinkedInIcon fontSize='large'/>},
        {name:'facebook', path:'https://www.facebook.com/PanguEnterprises' ,icon:<FacebookIcon fontSize='large'/>},
        {name:'X', path:'', icon:<XIcon fontSize='large'/>},
        {name:'instagram', path:'https://www.instagram.com/panguventures/', icon:<InstagramIcon fontSize='large'/>},
        // {name:'Pinterest', icon:<PinterestIcon />},
    ]

    const footerContact =[
        {name:'Email:', text: ' info@pangu.ventures', path:'/'},
        {name:'Phone:', text: ' +1 (778) 651 - 8765', path:'/'}
    ]

    const textColor = '#fefefe';
  return (
    <Box
        sx={{
        }}
    >
        <Box
            sx={{
                minHeight:'20vh',
                paddingTop:'2rem',
                backgroundColor:'rgba(0, 0, 0, 0.4)',
                color: textColor
            }}
        >
            <Box
                sx={{
                    display:'flex',
                    flexDirection:'row',
                    width:'100%',
                    gap:'1rem',
                    justifyContent:'space-evenly',
                    flexWrap:'wrap',
                    '@media screen and (max-width:762px)':{
                    }
                }}
            >
                {footerMenu.map((item, index) => (
                    <Box
                        key={index}
                    >
                        <Button
                            variant='outlined'
                            href='/services'
                            sx={{
                                borderColor:textColor,
                                color:textColor,
                                borderWidth:'0.1rem',
                                transition: 'transform 0.5s ease-in-out', // transition smoothing
                                '&:hover':{
                                    backgroundColor:'var(--color-secondary)',
                                    borderColor:'var(--color-secondary)'
                                },
                            }}
                        >{item.name}</Button>
                    </Box>

                ))}
            </Box>

            <Box
                sx={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    width:'100%',
                    justifyContent:'space-evenly',
                    marginTop:'2rem',
                    '@media screen and (max-width:762px)':{
                        flexDirection:'column',
                    }
                }}
            >
                <Box
                    sx={{
                        display:'flex',
                        flexDirection:'column',
                        width:'30%',
                        alignItems:'center',
                        
                    }}
                >
                    <Box // logo && Brand Name
                        sx={{
                        display:'flex',
                        flexDirection:'row',
                        padding:'1rem'
                        }}
                    >
                        <Box // logo
                        sx={{
                            width:'3rem',
                            alignContent:'center',
                            marginX:'1rem'
                        }}
                        >
                            <FlipCard>
                                <Box
                                    component='img'
                                    src={logoTransparent}
                                    sx={{
                                    width: '3rem',
                                    display:'flex'
                                    }}
                                />
                            </FlipCard>
                        </Box>
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'column'
                            }}
                        >
                            <Box
                                sx={{
                                    textDecoration:'none',
                                    color:'#000',
                                    display:'flex',
                                    flexDirection:'column'
                                }}
                            >
                                {footerContact.map((item, index) => (
                                    <Box
                                        sx={{
                                            display:'flex',
                                            flexDirection:'row',
                                            alignItems:'center',
                                            color:textColor
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily:'var(--text-font)',
                                                fontSize:'1rem'
                                            }}
                                        >{item.name}</Typography> 
                                        <Link
                                            sx={{
                                                paddingLeft:'0.2rem',
                                                color:textColor,
                                                textDecoration:'none',
                                                fontFamily:'var(--text-font)',
                                                fontSize:'1rem'
                                            }}
                                        >{item.text}</Link>
                                    </Box>
                                ))}
                        </Box>
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display:'flex',
                        flexDirection:'row',
                        width:'40%',
                        justifyContent:'center',
                        alignContent:'center',
                        alignItems:'center'

                    }}
                >
                    {footerIcons.map((icon, index) => (
                        <Box
                            sx={{
                                marginX:'1rem',
                                
                            }}
                        >
                            <Button
                                href={icon.path}
                                target='_blank'
                                sx={{
                                    color:textColor
                                }}
                            >{icon.icon}</Button>
                        </Box>
                    ))}
                </Box>

                <Box
                    sx={{
                        width:'30%'
                    }}
                >

                </Box>
            </Box>
            <Box
                    sx={{
                        width:'100%',
                        justifyContent:'flex-end',
                        display:'flex',
                        alignSelf:'flex-end',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize:'0.7rem',
                            fontFamily:'var(--text-font)',
                            padding:'1rem',
                            fontWeight:''
                        }}
                    >Copyright &copy; Pangu Enterprise Incorporated. {new Date().getFullYear()}. All rights reserved</Typography>
                </Box>
        </Box>
    </Box>
  )
}

export default Footer